

export const LeftBanner = () => {
  return (
    <div className="relative flex items-center justify-between rounded-none content-between my-6 -mt-8">
      <img src='/images/record.png' className="h-32 w-auto" alt="record" height="100" width="100" />
    </div>
  );
};
